//src/pages/Materials/MaterialAssign.js
import React, { useState, useEffect } from 'react';
import { assignMaterialToProject, getMaterial } from '../../api/material/MaterialApi'; // Import API helper functions
import { getProjects } from '../../api/project/projectApi';
import { useNavigate } from 'react-router-dom';
import { closeIcon } from '../../assets/icons/icons';
import Loader from '../../components/common/Loader/Loader';
import { IoCloseCircle } from 'react-icons/io5';
import { MdAddBox } from 'react-icons/md';

const MaterialAssign = ({ material, onClose }) => {
  const [projects, setProjects] = useState([]);
  const [project_id, setProject_id] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const user_id = localStorage.getItem('user_id');

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await getProjects(user_id);
        setProjects(response.data.projects);
      } catch (err) {
        console.error('Error Fetching assessments:', err);
      }
    };
    fetchProjects();
  }, [user_id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!project_id) {
      alert('Please select an assessment');
      return;
    }

    if (loading) return;
    setLoading(true);

    try {
      const formData = {
        material_id: material.material_id,
        new_project_id: project_id, // Target project for duplication
      };

      const response = await assignMaterialToProject(formData);

      if (response.status === 201) {
        alert('Material assigned successfully');
        const updatedMaterials = await getMaterial(user_id, project_id);
        navigate(`/material_list/${project_id}`);
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        alert('Maximum number of materials reached for this assessment.');
      } else {
        console.error('Error assigning material:', error);
        alert('Failed to assign material');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full flex items-center justify-center">
      {loading ? (
        <div className="w-full h-screen mx-auto">
          <Loader message="Assigning the material... this may take a few seconds." />
        </div>
      ) : (
        <div className="border-2 md:rounded-3xl rounded-lg p-3 lg:w-6/12 md:w-8/12 w-11/12 mx-auto bg-white shadow-[-7px_7px_28px_0px_rgba(45,61,111,0.71)]">
          <IoCloseCircle aria-label="close"
            className="ml-auto cursor-pointer md:text-2xl text-xl text-red-600"
            onClick={onClose}
          />
          <form
            onSubmit={handleSubmit}
            className="items-center rounded md:w-10/12 w-full mx-auto md:mb-8 mb-4"
          >
            <label className="block md:mb-2 mb-1 font-semibold text-sm md:text-base">
              Select Assessment:
            </label>
            <select
              value={project_id}
              onChange={(e) => setProject_id(e.target.value)}
              className="block w-full md:p-3 p-1.5 md:text-base text-sm border border-gray-300 rounded mb-4 text-purple-700 focus:outline-purple-500"
              style={{
                boxShadow: "1px -1px 10px 0px #B1C2F4 inset, -1px 3px 9px 0px #C8DBED inset"
              }}
            >
              <option value="">Select a project</option>
              {projects?.map((project) => (
                <option key={project.project_id} value={project.project_id}>
                  {project.project_name}
                </option>
              ))}
            </select>

            <button
              type="submit"
              disabled={loading}
              className={`mx-auto md:px-10 px-5 md:py-2 py-1.5 md:text-base text-sm rounded flex items-center justify-center gap-3 ${
                loading
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-green-500 text-white hover:bg-green-600'
              }`}
            >
              <span>Assign Material</span>
              <MdAddBox aria-label="plus" className='text-black md:text-xl text-base'/>
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default MaterialAssign;